import { createSlice } from "@reduxjs/toolkit";
import { AuthUser } from "@src/@types/AuthUser";


const INITIAL_STATE: AuthUser = {
    id: "",
    fullName: "",
    email: "",
    token: "",
    roles: [],
    refreshToken: "",
    authenticated: false,
    username: ""
}

export function authUser(state = INITIAL_STATE, action: { type: string; user: AuthUser; }){
    if(action.type === 'UPDATE_USER'){
        console.log('user received')
        console.log(action.user)
        state = action.user
    }
    return state;
}

const restoreUser = ():AuthUser => {
    let authUser = window.localStorage.getItem("authUser");
    console.log(authUser)
    if(authUser) {
        return JSON.parse(authUser);
    } 
    return INITIAL_STATE;
}

const restoreIsToSaveToStorage = ():boolean => {
    const savetoStorage = window.localStorage.getItem("saveToStorage");
    return savetoStorage ? JSON.parse(savetoStorage) : false;
}


export const authUserSlice = createSlice({
    name: "authUser",
    initialState:{
        authUser: restoreUser(),
        saveToStorage: restoreIsToSaveToStorage(),
        token: 'Bearer ' + restoreUser().token,
        logged: false
    },
    reducers:{
        handleAuthUser: (state, action) => {
            console.log("handle User account --" + JSON.stringify(action.payload) )
            state.authUser =  action.payload;
            window.localStorage.setItem("authUser", JSON.stringify(action.payload));
            window.localStorage.setItem("authToken", action.payload.token);
            state.logged = true;
        },
        handleSaveToStorage: (state, action) => {
            state.saveToStorage =  action.payload;
            window.localStorage.setItem("saveToStorage", JSON.stringify(action.payload));
        },
        handleRevokeToken: () => {
            console.log("Cleaning user from redux");
            window.localStorage.removeItem("authUser");
            window.localStorage.removeItem("authToken");
        },
        handleSetLogged:(state, action) => {
            state.logged = action.payload;
        },
        initRestoreUser: () => {
            restoreUser();
        },

    },

})
export const{
    handleAuthUser,
    handleSaveToStorage,
    handleRevokeToken,
    handleSetLogged,
    initRestoreUser
} = authUserSlice.actions;

export default authUserSlice.reducer;
